import _isEqual from "lodash/isEqual";
import _cloneDeep from "lodash/cloneDeep";
import {SetProperties} from "@/models/SetProperties";

export class TrainingCertificateParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(TrainingCertificate.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, TrainingCertificate.build(item))
  }

  remove(item) {
    const index = this.list.findIndex(el => _isEqual(_cloneDeep(el), _cloneDeep(item)))
    index >=0 && this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => TrainingCertificate.build(el))
    }
    return this
  }
}

export class TrainingCertificate extends SetProperties{
  constructor() {
    super()
    this.id = null
    this.application = null
    this.series = null
    this.number = null
    this.issueDate = null
    this.organization = null
    this.organizationName = null

    this.filesData = {}
  }

  getForAPI() {
    return {
      id: this.id,
      application: this.application,
      series: this.series,
      number: this.number,
      issueDate: this.issueDate,
      organization: this.organization,
      organizationName: this.organization?.name || this.organizationName
    }
  }

  static build(obj) {
    const _this = new TrainingCertificate()
    if (obj) {
      _this.id = obj.id
      _this.application = obj.application
      _this.series = obj.series
      _this.number = obj.number
      _this.issueDate = obj.issueDate
      _this.organization = obj.organization
      _this.organizationName = obj.organizationName
    }
    return _this
  }
}
